module.exports = __webpack_public_path__ + "img/ComingSoon.4704d52f.png";